import { Component } from "react";
import { getTokenDateDelta } from "./auth.utilities";

import Chip from "@material-ui/core/Chip";

export default class AuthTimer extends Component {
  constructor(props) {
    super(props);
    this.state = { seconds: -1 };
  }

  componentDidMount() {
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick() {
    let timeLeft = Math.round(getTokenDateDelta());
    this.setState({ seconds: timeLeft });
    if (timeLeft < 0) {
      clearInterval(this.interval);
      this.props.logout();
    }
  }

  render() {
    if (this.state.seconds > 0) {
      let minutes = Math.floor(this.state.seconds / 60);
      let seconds = Math.round(this.state.seconds % 60);

      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      if (this.state.seconds < 120) {
        return (
          <div style={{ position: "fixed", bottom: "10px", right: "10px" }}>
            <Chip
              backgroundColor="#f33"
              labelColor="#fff"
              label={`Time until logout: ${minutes}:${seconds} s.`}
            />
          </div>
        );
      }

      return (
        <div>
          <Chip label={`Time until logout: ${minutes}:${seconds} s.`} />
        </div>
      );
    } else {
      return <div className="auth-timer" />;
    }
  }
}
